<!-- 完善个人信息 -->
<template>
  <div class='contact-info pad-side20'>
    <!-- <div class="pad-side20">
      <ProgressBar progress="100" />
    </div> -->
    <TheVerifyTypeNew :step="2"/>
    <span class="span_tip_title">您即将完成申请</span>
    <span class="span_tip_content">现请您完善以下信息</span>
    <span class="span_tip_content">*应监管及征信报送要求，请您补充个人资料</span>
    <div class="div_info_content">

      <CustomFormItemNew name="学历" placeholder="请选择学历等级" disabled v-model="pickerResult.education" @click.native="showPicker('education')" :underLine="true" :need="true" />
      <CustomFormItemNew name="婚姻状况" v-show="this.freeLoanData.productCode !== 'PD0002'" placeholder="请选择婚姻状况" disabled v-model="pickerResult.marryStatus" @click.native="showPicker('marryStatus')" :underLine="true" :need="true" />
      <CustomFormItemNew name="婚姻状况" v-show="this.freeLoanData.productCode === 'PD0002'" placeholder="请选择婚姻状况" disabled v-model="pickerResult.marryStatus" @click.native="showPicker('marryStatus2')" :underLine="true" :need="true" />

      <!-- 非极速贷才显示下面这四个字段 -->
      <CustomFormItemNew name="有无子女" v-show="this.freeLoanData.productCode !== 'PD0002'" placeholder="请选择有无子女" disabled v-model="pickerResult.childStatus" @click.native="showPicker('childStatus')" :underLine="true" :need="true" />
      <CustomFormItemNew name="住宅性质" v-show="this.freeLoanData.productCode !== 'PD0002'" placeholder="请选择住宅性质" disabled v-model="pickerResult.addCate" @click.native="showPicker('addCate')" :underLine="true" :need="true" />
      <CustomFormItemNew name="雇佣类型" v-show="this.freeLoanData.productCode !== 'PD0002'" placeholder="请选择雇佣类型" disabled v-model="pickerResult.employmentType" @click.native="showPicker('employmentType')" :underLine="true" :need="true" />
      <CustomFormItemNew name="任职部门" v-show="this.freeLoanData.productCode !== 'PD0002'" placeholder="请输入任职部门" v-model="freeLoanData.department" :underLine="true" :need="true" />

      <!-- 只有极速贷显示下面两个字段  -->
      <CustomFormItemNew name="行业类型" v-show="this.freeLoanData.productCode === 'PD0002'" placeholder="请选择行业类型" disabled v-model="pickerResult.indNature" @click.native="showPicker('indNature')" :underLine="true" :need="true" />
      <CustomFormItemNew name="月均收入" v-show="this.freeLoanData.productCode === 'PD0002'" placeholder="请选择月均收入" disabled v-model="pickerResult.monthly" @click.native="showPicker('monthly')" :underLine="true" :need="true" />

      <CustomFormItemNew name="职位" placeholder="请输入职务/职位" v-model="freeLoanData.position" :underLine="true" :need="true" />
      <CustomFormItemNew name="入职时间" placeholder="请选择入职时间" disabled v-model="workDate" @click.native="showPicker('yearsOfWork')" :underLine="true" :need="true" />
      <!-- 随心贷固定用途为生活消费 -->
      <CustomFormItemNew name="借款用途" v-show="this.freeLoanData.productCode !== 'PD0003'" placeholder="请选择借款用途" disabled v-model="pickerResult.usage" @click.native="showPicker('usage')" :underLine="true" :need="true" />
      <CustomFormItemNew name="借款用途" v-show="this.freeLoanData.productCode === 'PD0003'" placeholder="请输入借款用途" disabled v-model="defaultOtherUsage" :underLine="true" :need="true" />
      <CustomFormItemNew name="其他用途" v-show="this.pickerResult.usage === '其他'" placeholder="请输入其他用途"  v-model="defaultOtherUsage" :underLine="true" :need="true" />

      <CustomFormItemNew name="电子邮箱" v-model="freeLoanData.email" :need="true" />
    </div>

    <div class="btn-wrap flex justify-content-center">
      <input type="button" :value="btnText" class="lg-btn btn_next" :class="btnClass" @click="confirm" :disabled="isDisabled">
    </div>

    <DefaultPicker ref="education" :columns="educationColumns" @onConfirm="onPickerConfirm('education', $event)" />
    <DefaultPicker ref="marryStatus" :columns="marryStatusColumns" @onConfirm="onPickerConfirm('marryStatus', $event)" />
    <DefaultPicker ref="marryStatus2" :columns="marryStatusColumns2" @onConfirm="onPickerConfirm('marryStatus2', $event)" />
    <DefaultPicker ref="indNature" :columns="indNatureColumns" @onConfirm="onPickerConfirm('indNature', $event)" />
    <DefaultPicker ref="monthly" :columns="monthlyColumns" @onConfirm="onPickerConfirm('monthly', $event)" />
    <DefaultPicker ref="childStatus" :columns="childStatusColumns" @onConfirm="onPickerConfirm('childStatus', $event)" />
    <DefaultPicker ref="addCate" :columns="addCateColumns" @onConfirm="onPickerConfirm('addCate', $event)" />
    <DefaultPicker ref="employmentType" :columns="employmentTypeColumns" @onConfirm="onPickerConfirm('employmentType', $event)" />
    <DefaultPicker ref="yearsOfWork" :columns="yearsOfWorkColumns" @onConfirm="onPickerConfirm('yearsOfWork', $event)" />
    <DefaultPicker ref="usage" :columns="usageColumns" @onConfirm="onPickerConfirm('usage', $event)" />

    <van-popup v-model="showProtolDialog" class="my-dialog">
      <h3>综合授权书</h3>
      <div class="content">抱歉，由于网络通讯异常，电子签章失败，请您再次阅读并同意<span @click="navitageToProtol(10)">《综合授权书》</span>。</div>
      <div class="btn-wrap flex justify-content-between">
        <input type="button" value="拒绝" class="mid-btn" @click="refuse">
        <input type="button" value="同意" class="hollow-btn" @click="agree">
      </div>
    </van-popup>
  </div>
</template>

<script>
import CustomFormItemNew from "@/components/CustomFormItemNew.vue";
import TheVerifyTypeNew from '@/components/TheVerifyTypeNew.vue';
import ProgressBar from "@/components/ProgressBar";
import { mapState } from 'vuex';
import { checkEmail } from '@/utils/verifyFunc';
import { Uploader } from 'vant';
import DefaultPicker from "@/components/DefaultPicker";
import { reqApplyAcc, applyAccAreaCheck, reqSignatures } from "@/api";
import sensors from 'sa-sdk-javascript'
export default {
  name: 'ContactInfo',

  components: {
    DefaultPicker,
    CustomFormItemNew,
    TheVerifyTypeNew,
    ProgressBar,
    [Uploader.name]: Uploader
  },

  data () {
    return {
      isDisabled: false,
      pickerResult: {
        education: '',
        marryStatus: '',
        childStatus: '',
        addCate: '',
        employmentType: '',
        usage: '',
        monthly: '',
        indNature: '',
      },
      education: [
        {name: '硕士及以上', mark: 1},
        {name: '本科', mark: 2},
        {name: '大专', mark: 3},
        {name: '中专', mark: 4},
        {name: '高中以下', mark: 5},
      ],
      marryStatus: [
        {name: '未婚', mark: 1},
        {name: '已婚', mark: 2},
        {name: '离异', mark: 4},
        {name: '其他', mark: 99},
      ],
      marryStatus2: [
        {name: '未婚', mark: 1},
        {name: '已婚有子女', mark: 5},
        {name: '已婚无子女', mark: 6},
        {name: '离异', mark: 4},
        {name: '其他', mark: 99},
      ],
      childStatus: [
        {name: '有', mark: 1},
        {name: '无', mark: -2},
      ],
      addCate: [
        {name: '自置', mark: 1},
        {name: '按揭', mark: 2},
        {name: '亲属楼宇', mark: 3},
        {name: '集体宿舍', mark: 4},
        {name: '租房', mark: 5},
        {name: '共有住宅', mark: 6},
        {name: '其他', mark: 99},
      ],
      employmentType: [
        {name: '受薪（一般上班族）', mark: '01'},
        {name: '自雇（营业执照客户）', mark: '02'},
      ],
      usage: [
        {name: '家用电器', mark: 1},
        {name: '手机数码', mark: 2},
        {name: '旅游', mark: 3},
        {name: '装修', mark: 4},
        {name: '教育', mark: 5},
        {name: '婚庆', mark: 6},
        {name: '租房', mark: 8},
        {name: '家具家居', mark: 9},
        {name: '健康医疗', mark: 10},
        {name: '其他', mark: 7},
      ],
      indNature: [
        {name: '住宿和餐饮业', mark: 6},
        {name: '批发和零售业', mark: 2},
        {name: '服务业', mark: 12},
        {name: '制造业', mark: 1},
        {name: '农业', mark: 16},
        {name: '其他', mark: 99},
      ],
      monthly: [
        {name: '0-3000', mark: '0-3000'},
        {name: '3001-5000', mark: '3001-5000'},
        {name: '5001-8000', mark: '5001-8000'},
        {name: '8001-10000', mark: '8001-10000'},
        {name: '10001-20000', mark: '10001-20000'},
        {name: '20001以上', mark: '20001以上'},
      ],
      workDate: '',
      trackInfo: {
        product_name: '',// * 产品名称
        loan_purpose: '',// * 贷款用途
        referee_code: '',// * 推荐人编码
        case_code: '',// * 专案编码
        gender: '',// * 性别
        age: 0,// * 年龄
        register_sources: '',// * 注册来源
        bank_name: '',// * 还款账户银行
        householdprovince: '',// * 户籍地省份
        householdcity: '',// * 户籍地城市
        residentialprovince: '',// * 现居住省份
        residentialcity: '',// * 现居住城市
        residentialtype: '',// * 住宅性质
        industry_type: '',// * 行业
        employtype: '',// * 雇佣类型
        education: '',// * 学历
        marriage: '',// * 婚姻状态
        is_success: false,// * 是否成功
        fail_reason: '',// * 失败原因
      },
      profileSetInfo: {
        age: 0,
        phone: '',
        bank_name: '',
        gender: '',
        mail_box: '',
        householdprovince: '',
        householdcity: '',
        residentialprovince: '',
        residentialcity: '',
        industry_type: '',
        residentialtype: '',
        employtype: '',
        socialidentity: '',
        education: '',
        marriage: '',
        apply_account: 20000,
        is_apply: true,
        loan_purpose: '',
        referee_code: '',
        case_code: '',
        birth_year: '',
        birth_month: '',
        birth_date: '',
      },
      otherUsage: '',
      defaultOtherUsage: '',
      enterTime: 0,
      showProtolDialog: false,
      btnText: '提交信息 获取额度',
      btnClass: '',
      count: 0,
      timer: null,
    };
  },

  computed: {
    ...mapState(['UA', 'freeLoanData', 'userInfo', 'OCRData']),
    educationColumns() {
      return this.returnColumns(this.education)
    },
    marryStatusColumns() {
      return this.returnColumns(this.marryStatus)
    },
    marryStatusColumns2() {
      return this.returnColumns(this.marryStatus2)
    },
    indNatureColumns() {
      return this.returnColumns(this.indNature)
    },
    monthlyColumns() {
      return this.returnColumns(this.monthly)
    },
    childStatusColumns() {
      return this.returnColumns(this.childStatus)
    },
    addCateColumns() {
      return this.returnColumns(this.addCate)
    },
    employmentTypeColumns() {
      return this.returnColumns(this.employmentType)
    },
    yearsOfWorkColumns() {
      let year = new Date().getFullYear();
      let columns = [
        {
          values: []
        },
        {
          values: []
        }
      ];
      let yearCol = {
        values: [],
        defaultIndex: 0
      };
      let monthCol = {
        values: [],
        defaultIndex: 0
      }
      for(let i = year; i > year - 100; i--) {
        yearCol.values.push(i)
      }
      for(let i = 1;i<13;i++) {
        monthCol.values.push(i)
      }
      columns[0] = yearCol
      columns[1] = monthCol
      return columns;
    },
    usageColumns() {
      return this.returnColumns(this.usage)
    },
  },

  created() {
    let key = 'phone' + localStorage.phone
    let reqData = {}
    if (localStorage[key]) {
      reqData = JSON.parse(localStorage[key])
      this.freeLoanData.education = reqData.education
      if (reqData.education) {
        this.pickerResult.education = this.education.filter(item => item.mark == reqData.education)[0].name
      }
      this.freeLoanData.marryStatus = reqData.marryStatus
      if (reqData.marryStatus) {
        this.pickerResult.marryStatus = this.marryStatus.filter(item => item.mark == reqData.marryStatus)[0].name
      }
      this.freeLoanData.childStatus = reqData.childStatus
      if (reqData.childStatus) {
        this.pickerResult.childStatus = this.childStatus.filter(item => item.mark == reqData.childStatus)[0].name
      }
      this.freeLoanData.addCate = reqData.addCate
      if (reqData.addCate) {
        this.pickerResult.addCate = this.addCate.filter(item => item.mark == reqData.addCate)[0].name
      }
      this.freeLoanData.employmentType = reqData.employmentType
      if (reqData.employmentType) {
        this.pickerResult.employmentType = this.employmentType.filter(item => item.mark == reqData.employmentType)[0].name
      }
      this.freeLoanData.department = reqData.department
      this.freeLoanData.position = reqData.position
      this.freeLoanData.yearsOfWork = reqData.yearsOfWork
      this.freeLoanData.monthsOfWork = reqData.monthsOfWork
      this.workDate = reqData.yearsOfWork + '-' + reqData.monthsOfWork
      this.freeLoanData.email = reqData.email
    }

    if (this.freeLoanData.productCode === 'PD0003') {
      //随心贷
      this.pickerResult.usage = '生活消费'
      this.freeLoanData.usage = '7'
      this.defaultOtherUsage = '生活消费'
      this.freeLoanData.others = '生活消费'
      this.freeLoanData.amount = '9000'
    } else {
      //生活贷极速贷
      if (this.freeLoanData.productCode === 'PD0001'){
        this.freeLoanData.amount = '200000'
      } else {
        this.freeLoanData.amount = '50000'
      }
      this.freeLoanData.usage = reqData.usage
      if (reqData.usage) {
        this.pickerResult.usage = this.usage.filter(item => item.mark == reqData.usage)[0].name;
        this.otherUsage = ''
        // this.freeLoanData.others = '';
      }
    }
    this.enterTime = new Date().getTime() / 1000;
  },

  activated() {

  },
  methods: {

    returnColumns(objArr) {
      let columns = [];
      objArr.forEach(item => {
        columns.push(item.name)
      })
      return columns
    },

    showPicker(type) {
      this.$refs[type].show = true
    },

    onPickerConfirm(type, val) {
        this.pickerResult[type] = val.value
        console.log("---onPickerConfirm：" + type + ",val：" + JSON.stringify(val));
        // console.log("---this[type][val.index].mark："+this[type][val.index].mark);
        if (type === 'yearsOfWork') {
            this.freeLoanData[type] = val.value[0]
            let month = val.value[1]
            month = month < 10 ? '0' + month : month
            this.freeLoanData.monthsOfWork = month
            this.workDate = val.value[0] + '-' + month
        } else if (type === 'marryStatus2') {
            this.pickerResult['marryStatus'] = val.value
            this.freeLoanData['marryStatus'] = this[type][val.index].mark
        } else {
            this.freeLoanData[type] = this[type][val.index].mark
        }
        if (type === 'usage') {
            this.defaultOtherUsage = val.value === '其他'?'日常消费':'';
        }
    },

    confirm() {
      if (this.btnClass === 'gray') {
        this.$toast("等待电子签章，请稍后！")
        return;
      }
      // console.info(JSON.stringify(this.freeLoanData))
      let { freeLoanData, userInfo, pickerResult } = this;
      if(!pickerResult.education) {
        this.$toast("请选择学历等级")
        return;
      } else {
        this.trackInfo.education = pickerResult.education;
        this.profileSetInfo.education = pickerResult.education;
      }
      if (this.freeLoanData.productCode === 'PD0002') {
        if(!pickerResult.marryStatus2) {
          this.$toast("请选择婚姻状况")
          return;
        } else {
          this.trackInfo.marriage = pickerResult.marryStatus2;
          this.profileSetInfo.marriage = pickerResult.marryStatus2;
        }
        if(!pickerResult.indNature) {
          this.$toast("请选择行业类型")
          return;
        } else {
          this.trackInfo.industry_type = pickerResult.indNature;
          this.profileSetInfo.industry_type = pickerResult.indNature;
        }
        if(!pickerResult.monthly) {
          this.$toast("请选择月均收入")
          return;
        }
      } else {
        if(!pickerResult.marryStatus) {
          this.$toast("请选择婚姻状况")
          return;
        } else {
          this.trackInfo.marriage = pickerResult.marryStatus;
          this.trackInfo.profileSetInfo = pickerResult.marryStatus;
        }
        if(!pickerResult.childStatus) {
          this.$toast("请选择有无子女")
          return;
        }
        if(!pickerResult.addCate) {
          this.$toast("请选择住宅性质")
          return;
        } else {
          this.trackInfo.residentialtype = pickerResult.addCate;
          this.profileSetInfo.residentialtype = pickerResult.addCate;
        }
        if(!pickerResult.employmentType) {
          this.$toast("请选择雇佣类型")
          return;
        } else {
          this.trackInfo.employtype = pickerResult.employmentType;
          this.profileSetInfo.employtype = pickerResult.employmentType;
        }
        if(!freeLoanData.department) {
          this.$toast("请选择任职部门")
          return;
        }
      }
      if(!freeLoanData.position) {
        this.$toast("请输入职务/职位")
        return;
      }
      if(!freeLoanData.yearsOfWork) {
        this.$toast("请选择入职时间")
        return;
      }
      // console.log("---pickerResult.usage:"+pickerResult.usage+",freeLoanData.usage:"+this.freeLoanData.usage)
      // console.log("---this.defaultOtherUsage:"+this.defaultOtherUsage)
      if(!pickerResult.usage) {
        this.$toast("请选择借款用途")
        return;
      } else {
        this.trackInfo.loan_purpose = pickerResult.usage;
        this.profileSetInfo.loan_purpose = pickerResult.usage;
      }
      //其他用途
      if (this.pickerResult.usage === '其他') {
        this.freeLoanData.others = this.defaultOtherUsage;
        if (!freeLoanData.others) {
          this.$toast("请输入其他用途")
          return;
        }
      }
      if(!checkEmail(freeLoanData.email)) {
        this.$toast("请填写正确的邮箱")
        return;
      }
      if (this.freeLoanData.productCode !== 'PD0003' && this.pickerResult.usage !== '其他') {
        freeLoanData.others = '';
      }
      var othersRule = /车|房|楼|股票|投资|经营|周转|理财|首付|生产|代偿|证券|炒股|还款|偿还欠款|债券|期货|赌博|吸毒/;
      if (othersRule.test(freeLoanData.others)) {
        this.$dialog.alert({
          title: "提示",
          message: '本贷款不可用于购车、购房、经营类以及证券投资等非合同规定范围的用途，也必须匹配您实际的资金使用，请您知悉并审慎选择。',
          showCancelButton: true
        });
        freeLoanData.others = '';
        return;
      }
      if (freeLoanData.others) {
        this.trackInfo.loan_purpose = freeLoanData.others;
        this.profileSetInfo.loan_purpose = freeLoanData.others;
      }
      // console.log("---SSS:"+JSON.stringify(freeLoanData))
      //设置神策埋点数据
      this.trackInfo.product_name = sessionStorage.getItem('tempProductName');
      this.trackInfo.bank_name = this.freeLoanData.bankName;
      this.trackInfo.register_sources = this.userInfo.registerChannel || "WeChatH5";
      this.trackInfo.gender = "1" === freeLoanData.sex ? "男" : "女";
      this.trackInfo.age = this.getAge(freeLoanData.idNo);
      this.trackInfo.residentialprovince = localStorage.getItem("residentialprovince");
      this.trackInfo.residentialcity = localStorage.getItem("residentialcity");
      this.profileSetInfo.age = this.getAge(freeLoanData.idNo);
      this.profileSetInfo.bank_name = this.freeLoanData.bankName;
      this.profileSetInfo.phone = localStorage.getItem('phone');
      this.profileSetInfo.mail_box = freeLoanData.email;
      this.profileSetInfo.socialidentity = freeLoanData.position;
      this.profileSetInfo.gender = "1" === freeLoanData.sex ? "男" : "女";
      this.profileSetInfo.residentialprovince = localStorage.getItem("residentialprovince");
      this.profileSetInfo.residentialcity = localStorage.getItem("residentialcity");
      this.profileSetInfo.referee_code = freeLoanData.recomNo;
      this.profileSetInfo.case_code = freeLoanData.projectCode;
      //生日
      if (freeLoanData.birthday) {
        var birthday = freeLoanData.birthday.replace(new RegExp("-", "g"), "");
        this.profileSetInfo.birth_year = parseInt(birthday.substring(0,4));
        this.profileSetInfo.birth_month = parseInt(birthday.substring(4,6));
        this.profileSetInfo.birth_date = parseInt(birthday.substring(6,8));
      }
      //户籍地址
      let regex = "(?<province>[^省]+省|.+自治区)(?<city>[^自治州]+自治州|[^市]+市|[^盟]+盟|[^地区]+地区|.+区划)(?<county>[^市]+市|[^县]+县|[^旗]+旗|.+区)?(?<town>[^区]+区|.+镇)?(?<village>.*)";
      var idCardAddress = localStorage.getItem("idCardAddress");
      var province = idCardAddress.match(regex).groups['province'];
      var city = idCardAddress.match(regex).groups['city'];
      this.profileSetInfo.householdprovince = province;
      this.profileSetInfo.householdcity = city;
      this.trackInfo.householdprovince = province;
      this.trackInfo.householdcity = city;
      //上报
      sensors.setProfile(this.profileSetInfo);
      //
      let channelFrom = sessionStorage.getItem("channelFrom");
      if (channelFrom) {
        this.freeLoanData.channel = channelFrom;
      } else {
        this.freeLoanData.channel = "WeChatH5";
      }
      this.freeLoanData.uuid = this.UA;
      let key = 'phone' + localStorage.getItem('phone')
      localStorage.setItem(key, JSON.stringify(freeLoanData));
      let lat = sessionStorage.getItem("lat");
      let lng = sessionStorage.getItem("lng");
      if (!lat || !lng) {
        this.$dialog.alert({
          title: "提示",
          message: "抱歉，读取位置信息失败，请重新打开申请页进行申请",
          showCancelButton: true
        });
        return;
      }
      sensors.track(freeLoanData.productCode === 'PD0003' ? 'Fill_workinfo' : 'Complete_info', {
        product_name: sessionStorage.getItem('tempProductName'),
        is_success: true,
        consume_time: new Date().getTime() / 1000 - this.enterTime,
      });
      let param = {
        idNo: freeLoanData.idNo,
        mobile: userInfo.phoneNo,
        prodCode: freeLoanData.productCode,
        comAdress: localStorage.getItem('CompanyCity') + freeLoanData.comAdd,
        currAdress: localStorage.getItem('CurrentCity') + freeLoanData.address,
        platform: 'Web',
        latitude: lat,
        longitude: lng,
      };
      applyAccAreaCheck(param).then(res => {
        this.doSign(freeLoanData, '1');
      }).catch(err => {
        this.$router.replace({
          name: 'FreeLoanResult',
          params: {msg: err.data.resMessage}
        })
      })
    },

    doSign(freeLoanData, type) {
      let params = {
        page: '0',
        type: type,
        prodCode: this.freeLoanData.productCode,
        phone: this.userInfo.phoneNo,
        idName: this.OCRData.name || this.freeLoanData.name,
        idNo: this.OCRData.idcard || this.freeLoanData.idNo,
      }
      reqSignatures(params).then(res => {
        this.applyAccRequest(freeLoanData);
        // this.$router.push('/verified-step2')
      }).catch(err => {
        if (err.data.resMessage.includes('生成失败') || err.data.resMessage.includes('签章失败')) {
          this.showProtolDialog = true;
        } else {
          this.$dialog.alert({
            title: "提示",
            message: err.data.resMessage,
            showCancelButton: true
          });
        }
      });
    },

    applyAccRequest(freeLoanData){
      var _this = this;
      reqApplyAcc(freeLoanData).then(res => {
        _this.trackInfo.is_success = true;
        sensors.track('SubmitLoanApplication', _this.trackInfo);
        if (typeof gdt === 'function') {
          gdt('track', 'RESERVATION', {'key1': 'value1', 'key2': 'value2'});
        }
        this.$router.replace({
          name: 'FreeLoanResult',
          params: {msg: '0'}
        })
      }).catch(err => {
        _this.trackInfo.is_success = false;
        _this.trackInfo.fail_reason = err.data.resMessage || '';
        sensors.track('SubmitLoanApplication', _this.trackInfo);
        this.$router.replace({
          name: 'FreeLoanResult',
          params: {msg: err.data.resMessage}
        })
      })
    },

    getAge(identityCard) {
      var len = (identityCard + "").length;
      if (len == 0) {
        return 0;
      } else {
        if ((len != 15) && (len != 18)) {
          return 0;
        }
      }
      var strBirthday = "";
      if (len == 18) {
        strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
      }
      if (len == 15) {
        strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
      }
      //时间字符串里，必须是“/”
      var birthDate = new Date(strBirthday);
      var nowDateTime = new Date();
      var age = nowDateTime.getFullYear() - birthDate.getFullYear();
      //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
      if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },

    refuse() {
      this.showProtolDialog = false;
    },

    agree() {
      let params = {
        page: '0',
        type: '0',
        prodCode: this.freeLoanData.productCode,
        phone: this.userInfo.phoneNo,
        idName: this.OCRData.name || this.freeLoanData.name,
        idNo: this.OCRData.idcard || this.freeLoanData.idNo,
      }
      reqSignatures(params).then(res => {
        this.showProtolDialog = false;
        this.count = 5;
        let _this = this;
        this.timer = setInterval(() => {
          if (_this.count !== 0) {
            _this.btnText = `${_this.count}s`;
            _this.btnClass = 'gray';
            _this.count--;
          } else {
            _this.btnText = '提交信息 获取额度';
            _this.btnClass = '';
            clearInterval(_this.timer);
          }
        }, 1000);
        // this.$router.push('/verified-step2')
      }).catch(err => {
        this.$dialog.alert({
          title: "提示",
          message: err.data.resMessage,
          showCancelButton: true
        });
      });
    },

    navitageToProtol(type) {
      this.$router.push(`/protol?type=${type}`)
    },
  },

  watch: {
    otherUsage(curVal, oldVal) {
      var othersRule = /车|房|楼|股票|投资|经营|周转|理财|首付|生产|代偿|证券|炒股|还款|偿还欠款|债券|期货|赌博|吸毒/;
      if (othersRule.test(curVal)) {
        this.$dialog.alert({
          title: "提示",
          message: '本贷款不可用于购车、购房以及证券投资等非合同规定范围的用途，请您知悉。',
          showCancelButton: true
        }).then(() => {
          this.otherUsage = '';
          this.freeLoanData.usage = '';
        });
      } else {
        this.freeLoanData.usage = curVal;
      }
    },
  },
}

</script>

<style lang='less' scoped>
  .contact-info {
    // width: 100%;
    height: auto;
    min-height: 100vh;
    /* min-height: calc(100vh - 46px); */
    background-color: #F5F5F5;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .span_tip_title {
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: bold;
    color: #333333;
    margin-left: 15px;
    margin-top: 8px;
  }

  .span_tip_content {
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-left: 15px;
    margin-top: 2px;
  }

  .div_info_content {
    width: 100%;
    height: auto;
    min-height: 50px;
    background-color: white;
    border-radius: 6px;
    margin-top: 31px;
    display: flex;
    flex-direction: column;
  }

  .btn_next {
    // width: 50%;
    height: 48px;
    // margin-left: 25%;
    margin-top: 30px;
    margin-bottom: 30px;
    background-color: rgb(228, 184, 18);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 19px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: white;
  }
  .shadow-box {
    background:rgba(255,255,255,1);
    box-shadow: 0px -10px 15px rgba(0,0,0,0.06);
    border-radius: 30px 30px 0px 0px;
    padding-top: 16px;
    padding-bottom: 34px;
    margin-top: 22px;
  }
  .title1 {
    color: #181819;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 4px;
  }
  .title2 {
    color: #181819;
    font-size: 18px;
    line-height: 25px;
    font-weight: bold;
    margin-bottom: 4px;
  }
  .title3 {
    color: #C5C5C5;
    font-size: 12px;
    line-height: 17px;
    margin-bottom: 20px;
  }
  .lg-btn {
    margin-top: 26px;
  }
  .support {
    font-size: 10px;
    color: #238DF8;
    text-align: right;
    padding-right: 16px;
  }
  .scan-icon {
    width: 20px;
  }
  .qrcode-txt {
    font-size: 17px;
    font-weight: bold;
    margin-right: 10px;
    min-width: 68px;
  }
  .qrcode {
    background-color: #F6F6F6;
    border-radius: 22px;
    line-height: 44px;
    margin: 10px 0;
    overflow: hidden;
    padding: 0 20px;
    input {
      background-color: #F6F6F6;
      margin-right: 10px;
    }
  }
  .custom-qrcode {
    display: flex;
    align-items: center;
  }
  .custom-qrcode /deep/ .btn {
    width: 108px;
    line-height: 32px;
    border-radius: 16px;
    color: #fff;
  }
  .custom-qrcode /deep/ .start {
    color: #181819;
  }
  .my-dialog {
    width:331px;
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    border-radius:15px;
    padding: 23px 32px;
    h3 {
      font-size: 17px;
      font-weight: bold;
      text-align: center;
    }
    .content {
      font-size: 14px;
      line-height: 28px;
      padding: 10px 0 20px;
      span {
        color: #238DF8;
      }
    }
    .btn-wrap {
      input {
        width: 125px;
        line-height: 36px;
      }
    }
  }

  .gray {
    /*grayscale(val):val值越大灰度就越深*/
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: #CCCCCC;
  }
</style>